const resource = {
  'x-red': null,
  'x-yellow': null,
  'x-blue': null,
  'x-red-3x': null,
  'x-yellow-3x': null,
  'x-blue-3x': null,
  'x-red-blurred': null,
  'x-yellow-blurred': null,
  'x-blue-blurred': null,
  'title-mei': null,
  'title-ge': null,
  'title-zhi': null,
  'title-hui': null,
  'title-gong': null,
  'title-yi': null,
  'title-bei': null,
  'title-hou': null,
  'title-dou': null,
  'title-you': null,
  'title-ling': null,
  'title-xi': null
}

for (const name in resource) {
  const img = document.createElement('img')
  img.crossOrigin = 'anonymous'
  img.src = `https://s.lingxi360.com/lingxi/asset/home/4/${name}.png`
  resource[name] = img
}

export default resource
